// utils/formatDelta.js

/**
 * Formats a delta (ratio) as a percentage and exposes its sign.
 * @param {number|null|undefined} delta - e.g. 0.156 => 15.6%
 * @param {object} [opts]
 * @param {number} [opts.decimals=2] - Number of decimals to display.
 * @param {boolean} [opts.includePlus=true] - Adds "+" if positive.
 * @returns {{
 *   formatted: string,        // e.g. "+15.60%"
 *   percentage: number,       // e.g. 15.6
 *   sign: 'positive'|'negative'|'neutral',
 * }}|null
 */
export function formatDelta(delta, opts = {}) {
  if (delta == null || !Number.isFinite(delta)) return null;

  const { decimals = 0, includePlus = true } = opts;

  // Calculate percentage rounded to `decimals`
  const factor = 10 ** decimals;
  const percentage = Math.round(delta * 100 * factor) / factor;

  // Determine the sign
  let sign = 'neutral';
  if (percentage > 0) sign = 'positive';
  else if (percentage < 0) sign = 'negative';

  // Build formatted string with + if positive
  const prefix = sign === 'positive' && includePlus ? '+' : '';
  const formatted = `${prefix}${percentage.toFixed(decimals)}%`;

  return { formatted, percentage, sign };
}
